var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6691 0.65625H5.00248C2.43582 0.65625 0.359149 2.75625 0.359149 5.32292L0.335815 42.6562C0.335815 45.2229 2.41248 47.3229 4.97915 47.3229H33.0025C35.5691 47.3229 37.6691 45.2229 37.6691 42.6562V14.6562L23.6691 0.65625ZM16.5291 37.9896L8.26915 29.7296L11.5591 26.4396L16.5058 31.3862L26.3991 21.4929L29.6891 24.7829L16.5291 37.9896ZM21.3358 16.9896V4.15625L34.1691 16.9896H21.3358Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment);
export default __webpack_public_path__ + "static/media/file_attachment.4304927d0e094c296e297285d3744f8d.svg";
export { ForwardRef as ReactComponent };